import { ContractorState } from "@ecp-redux/dto/contractorNip.types";

export const CONTRACTOR_NIP_EXIST_ECOM = {
  state: ContractorState.EXISTS_ECOM,
  information: {
    localization: "Warsaw",
    ph: "ph",
    dth: "dth",
    id: "111",
  },
};

export const CONTRACTOR_NIP_EXIST_ERP = {
  state: ContractorState.EXISTS_ERP,
  information: {
    localization: "Warsaw",
    ph: "ph",
    dth: "dth",
    id: "222",
  },
};

export const CONTRACTOR_NIP_NOT_EXIST = {
  state: ContractorState.NOT_EXISTS,
};
